<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        @save="$refs.Form.save()"
        large
        ref="Modal"
        title="Telefone"
    >
        <Form
            :data="data"
            @save="$refs.Modal.hide()"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    methods: {
        open() {

            this.$refs.Modal.show()
        },
    },
    props: {
        data: { type: Object, required: true }
    },
}
</script>